import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { PresentationBlock } from 'shared/components/PresentationBlock';
import { RootMortgageWrapper } from 'shared/constants/common';
import { selectH1Tag, selectSeoBreadcrumbItems } from '../../selectors/landing';
import { useTracking } from '../../utils/tracking/useTracking';

export const PresentationBlockContainer = () => {
  const { trackClickOnTargetButton } = useTracking();
  const title = useSelector(selectH1Tag);
  const breadcrumbs = useSelector(selectSeoBreadcrumbItems);

  const onScrollToMortgageBlock = useCallback(() => {
    trackClickOnTargetButton();
    const element = document.getElementById(RootMortgageWrapper);
    element?.scrollIntoView({
      behavior: 'smooth',
    });
  }, []);

  return (
    <PresentationBlock
      breadcrumbs={breadcrumbs}
      title={title}
      description="Льготные программы, эксклюзивные предложения — всё здесь"
      handleClickButton={onScrollToMortgageBlock}
    />
  );
};
